import React, { useState } from "react";
import {
  uploadUsertalentDocument,
  uploadTalentVideoToFirebase,
} from "../../utils/Network";

function UserTalentDocumentForm({ usertalent, editingItem, ...props }) {
  const [url, setUrl] = useState(null);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);
  const [progress, setProgress] = useState(null);

  const VIDEO_UPLOAD_ERROR = "Video upload failed. Please try again later.";

  const SaveChanges = () => {
    setError(null);

    if (!url) {
      setError("Please enter Url");
      return;
    }

    setLoading(true);
    uploadUsertalentDocument(
      usertalent.id,
      usertalent.talent.documents[0].id,
      url,
      null
    ).then((data) => {
      if (data.id) {
        setDone("Changes saved successfully");
        props.callback();
      }
      setLoading(false);
    });
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "url":
        setUrl(e.target.value);
        break;
      case "file":
        if (e.target.files) {
          setFile(e.target.files[0]);
          uploadTalentVideo(e.target.files[0]);
        }
        break;
      default:
        break;
    }
  };

  async function uploadTalentVideo(selectedFile) {
    setError(null);
    setLoading(true);
    setProgress(0);
    const result = await uploadTalentVideoToFirebase(selectedFile, (p) =>
      setProgress(p)
    );
    if (result.ok && result.public_url) {
      setProgress(100);
      setLoading(false);
      saveFirebaseUrl(result.public_url);
    } else {
      setProgress(null);
      setLoading(false);
      setError(result.error || VIDEO_UPLOAD_ERROR);
    }
  }

  const saveFirebaseUrl = (downloadUrl) => {
    setLoading(true);
    uploadUsertalentDocument(
      usertalent.id,
      usertalent.talent.documents[0].id,
      downloadUrl,
      null
    ).then((data) => {
      if (data.Error) alert(data.Error);
      else {
        props.callback();
      }
      setLoading(false);
    });
  };

  return (
    <div>
      <div className="form-group">
        <input
          type="text"
          value={url || ""}
          name="url"
          onChange={onChange}
          className="form-control post-title"
          placeholder="https://youtu.be"
        />
      </div>
      <div className="form-group">
        <input
          type="file"
          name="file"
          onChange={onChange}
          className="form-control "
        />
      </div>
      {progress != null && progress > 0 && progress < 100 && (
        <div className="alert alert-info mt-2">Uploading… {progress}%</div>
      )}
      <div className="form-group mt-10">
        <button
          className="btn btn-primary pull-right"
          onClick={SaveChanges}
        >
          {loading ? "" : "Save Changes"}
        </button>
        <div className="clear"></div>
      </div>
      {error && (
        <div className="alert alert-danger mt-5">{error}</div>
      )}
      {loading && (
        <div className="alert alert-info  mt-5">Please Wait...</div>
      )}
      {done && (
        <div className="alert alert-success  mt-5">{done}</div>
      )}
    </div>
  );
}

export default UserTalentDocumentForm;
